import {jwtServerInstance} from "../index";
import qs from	'qs'

//参数配置列表查询接口
export const queryBlackUsers = (queryForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cblackuser/query',
        method:'post',
        data:qs.stringify({
            userName: queryForm.customerName,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//删除一条sys_role数据记录
export const deleteBlackUser = (id) => {
    return jwtServerInstance.request({
        url:'/b2cblackuser/delete',
        method:'post',
        data:qs.stringify({
            id:id
        })
    })
}

//删除一条sys_role数据记录
export const deleteAllBlackUser = () => {
    return jwtServerInstance.request({
        url:'/b2cblackuser/deleteall',
        method:'post'
    })
}

//删除一条sys_role数据记录
export const addBlackUser = (blackUser) => {
    return jwtServerInstance.request({
        url:'/b2cblackuser/addblackuser',
        method:'post',
        data:qs.stringify({
            customer:blackUser.userName,
            beacuse: blackUser.beacuse,
            plateform: blackUser.plateform
        })
    })
}
